import i18n from 'i18next';
import { getFrequencies } from '../constants';

export function getImageUrl(name, config) {
    const baseUrl = config.apiUrl.split('/')[0] + "//" + config.apiUrl.split('/')[2] + "/Static/images/";
    const cacheBust = "?unity_version=" + window.unityVersion;
    let url = baseUrl + name + cacheBust;
    return url;
}

export function downloadFile(downloadUrl) {
    const isSafari = navigator.userAgent.toLowerCase().indexOf("safari") >= 0 && navigator.userAgent.toLowerCase().indexOf("chrome") < 0
    if (isSafari) {
        window.location = downloadUrl;
    } else {
        window.open(downloadUrl, '_blank');
    }
}

export function findField(form, fieldId) {
    if (form.fields) {
        for (let i = 0; i < form.fields.length; i++) {
            if (form.fields[i].id === fieldId)
                return form.fields[i];
            else if (form.fields[i].fields) {
                const found = form.fields[i].fields.find(sub => sub.id === fieldId);
                if (found)
                    return found;
            }
        }
    }
}

export function getFieldAndSubfields(field) {
    const all = field.fields ? field.fields.slice() : [];
    all.unshift(field);
    return all;
}

export function isEmptyGuid(guid) {
    return !guid || guid === "00000000-0000-0000-0000-000000000000";
}

export function generateGuid() {
    let d = new Date().getTime();

    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now();; //use high-precision timer if available
    };

    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });

    return uuid;
}

export function modifyState(state, event) {
    return { ...state, [event.target.name]: (event.target.type === 'checkbox' ? event.target.checked : event.target.value) };
}

export function getInstallments(freq, start, start2, end) {
    let current = new Date(start.valueOf());
    const dates = [];
    while (current <= end && dates.length < 1000) {
        dates.push(current);
        current = getNextOccurence(freq, current, start, start2);
    }
    return dates;
}

export function getNextOccurence(freq, current, start1, start2) {
    let next;
    freq = parseInt(freq);

    if (freq === 0)
        next = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 7);
    else if (freq === 1)
        next = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 14);
    else if (freq === 3) {
        next = addMonths(current, 0, start1);
        if (next <= current)
            next = addMonths(next, 1);

        let next2 = addMonths(current, 0, start2);
        if (next2 <= current)
            next2 = addMonths(next2, 1);

        if (next2 < next)
            next = next2;
    }
    else if (freq === 2)
        next = addMonths(current, 1, start1);
    else if (freq === 4)
        next = addMonths(current, 3, start1);
    else if (freq === 5)
        next = addMonths(current, 12, start1);
    return next;
}

export function addMonths(current, addMonths, dayOverride) {
    const year = current.getFullYear();
    const month = current.getMonth() + addMonths;
    const maxDays = daysInMonth(month + 1, year);
    const day = Math.min((dayOverride || current).getDate(), maxDays);
    return new Date(year, month, day);
}

export function daysInMonth(month, year) {
    // Pass in the calendar month (2 for Februrary)
    return new Date(year, month, 0).getDate();
}

const _numberSeparator = (1111).toLocaleString().indexOf(".") >= 0 ? "." : ",";
const _numberFormatterRegex = /\B(?=(\d{3})+(?!\d))/g;
const _numberSeparatorRegex = new RegExp("[" + _numberSeparator + "]", 'g');
export const _use12HourTime = new Date(2002, 2, 2, 23, 2, 2).toLocaleTimeString().indexOf("11") >= 0;
export function formatNumber(num) {
    let amt = parseNumber(num);
    if (isNaN(amt))
        return "";
    return amt.toString().replace(_numberFormatterRegex, _numberSeparator);
}

export function formatCurrency(num, allowNegative) {
    let amt = parseNumber(num);
    if (!allowNegative && amt < 0)
        amt = -amt;
    if (!isNaN(amt))
        return roundCurrency(amt).toFixed(2).replace(_numberFormatterRegex, _numberSeparator);
    return "";
}

export function formatCurrencyWithSymbol(num) {
    const text = formatCurrency(num, true);
    if (text === "")
        return "";
    if (num <= -.005)
        return "-$" + text.substr(1);
    return "$" + text;
}

export function formatCurrencyRange(num, withSymbol) {
    var amt = parseNumber(num);
    var rounded = Math.floor(amt * 100) / 100;
    var format = (withSymbol ? formatCurrencyWithSymbol : formatCurrency);
    if (amt - rounded > .001)
        return format(rounded) + " - " + format(rounded + .01);
    return format(amt);
}

export function roundCurrency(number) {
    return Math.round(number * 100 + .00001) / 100; // number might not be accurate due to floating point precision (.254999999998), so adjust by an amount smaller than should matter
}

export function isNullOrWhiteSpace(str) {
    if (typeof str === 'undefined' || str === null || str === "")
        return true;
    return !(/\S/.test(str));
}

export function isGreaterThanZero(str) {
    return parseNumber(str) > 0;
}

export let _datePlaceholder = null;
export const dateFormat = new Date(2000, 10, 22).toLocaleDateString().replace("2000", "YYYY").replace("11", "MM").replace("22", "DD").replace(/\u200E/g, ''); // month 10 is novmember because javascript, \u200E is a left-to-right character that IE11 inserts

export function datePlaceholder() {
    if (!_datePlaceholder && i18n.t('date.day') !== "date.day")
        _datePlaceholder = dateFormat.replace("DD", i18n.t('date.day')).replace("MM", i18n.t('date.month')).replace("YYYY", i18n.t('date.year'));
    return _datePlaceholder;
}

export function parseNumber(val, allowCurrency) {
    if (typeof (val) === "string") {
        val = val.trim().replace(_numberSeparatorRegex, '');
        if (allowCurrency && val[0] === "$")
            val = val.substring(1);
    }
    return parseFloat(val);
}

const browserMonthFirst = dateFormat.indexOf("MM") === 0;
export function parseDate(val, legacy = false) {
    if (!val)
        return null;

    if (typeof (val) === "string") {
        val = val.trim();
        if (val.indexOf('T') >= 0)
            val = val.substring(0, val.indexOf('T'));

        const parts = val.split(/[./-]/);
        if (parts.length !== 3)
            return null;

        let y, m, d;
        if (parts[0].length >= 3)
            [y, m, d] = parts.map(p => parseInt(p));
        else if (browserMonthFirst || (legacy && val.indexOf("/") > 0))
            [m, d, y] = parts.map(p => parseInt(p));
        else
            [d, m, y] = parts.map(p => parseInt(p));

        if (m === 0 || m > 12)
            return null;
        if (d === 0 || d > 31 || (d > 28 && d > daysInMonth(m, y)))
            return null;
        return new Date(y, m - 1, d);
    }
    else if (!(val instanceof Date))
        val = new Date(val);

    if (isNaN(val.getTime()))
        return null;
    return new Date(val.getFullYear(), val.getMonth(), val.getDate());
}

export function parseDateTime(val) {
    if (!val)
        return null;
    if (!(val instanceof Date))
        val = new Date(val);
    if (isNaN(val.getTime()))
        return null;
    return val;
}

export function isFutureDate(str, todayOverride = null) {
    const date = parseDate(str);
    if (date === null)
        return false;
    return date > (todayOverride || new Date());
}

export function isTodayOrFutureDate(str) {
    const date = parseDate(str);
    if (date === null)
        return false;
    return date >= getToday();
}

export function getToday() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export function getTomorrow() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
}

export function formatDate(date) {
    if (!(date instanceof Date)) {
        date = parseDate(date);
        if (!date)
            return "";
    }
    return date.toLocaleDateString().replace(/\u200E/g, ''); // \u200E is for IE11
}

export function formatDateIso(date) {
    if (!(date instanceof Date)) {
        date = parseDate(date);
        if (!date)
            return "";
    }
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
}

export function formatDateTime(date, format) {
    date = parseDateTime(date);
    if (!date)
        return "";

    let timeFormat;
    let dateFormat;
    if (format === "show-seconds")
        timeFormat = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
    else if (format === 'long') {
        dateFormat = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        timeFormat = { hour: 'numeric', minute: 'numeric' };
    } else
        timeFormat = { hour: 'numeric', minute: 'numeric' };

    const countryCode = []; // browser default
    return (date.toLocaleDateString(countryCode, dateFormat) + " " + date.toLocaleTimeString(countryCode, timeFormat)).replace(/\u200E/g, '');  // \u200E is for IE11
}

export function convertDateToISODateString(date) {
    if (!date || !date.valueOf())
        return null;
    return date.getFullYear() + "-" + ('0' + (date.getMonth() + 1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2);
}

export function formatPhone(val) {
    if (!val || !val.substring)
        return "";
    val = val.replace(/[^0-9]/g, '');

    if (val.length <= 3)
        return val;
    if (val.length <= 7)
        return "(" + val.substring(0, 3) + ") " + val.substring(3);
    if (val.length <= 10)
        return "(" + val.substring(0, 3) + ") " + val.substring(3, 6) + "-" + val.substring(6);
    if (val.length === 11)
        return "+" + val.substring(0, 1) + " (" + val.substring(1, 4) + ") " + val.substring(4, 7) + "-" + val.substring(7);
    return val;
}

export function equalDates(date1, date2) {
    const d1 = parseDate(date1);
    const d2 = parseDate(date2);
    if (!d1)
        return !d2;
    if (!d2)
        return false;
    return d1.valueOf() === d2.valueOf();
}

export function scrollToBottom(selector) {
    const e = document.querySelector(selector);
    e.scrollTop = e.scrollHeight - e.clientHeight;
}

export function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) >= 0;
}


export function isValidPhone(phone) {
    if (!phone || /[^0-9- ()]/.test(phone))
        return false;

    return phone.replace(/[^0-9]/g, '').length >= 10;
}

const _validEmailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export function isValidEmail(email, allowName) {
    if (!email)
        return false;

    // Check if it's a plain email address
    if (_validEmailRegex.test(email))
        return true;

    // Check if it's an email with name
    if (allowName && email.indexOf('<') > -1 && email.lastIndexOf('>') === email.length - 1) {
        const emailPart = email.substring(email.lastIndexOf("<") + 1, email.lastIndexOf(">"));
        if (_validEmailRegex.test(emailPart))
            return true;
    }

    return false;
}

export function isEmailOrEmailPlaceholder(text, placeholders, allowMulti) {
    if (!text || text.length <= 1)
        return false;

    // Check if it's an email address
    if (isValidEmail(text, true))
        return true;

    // Check if it's a placeholder
    if (text.indexOf('#') === 0 && text.lastIndexOf('#') === text.length - 1) {
        const name = text.substring(1, text.length - 1);
        var placeholder = placeholders && placeholders.find(f => f.name === name);
        if (placeholder && placeholder.type === "email" && (allowMulti || !placeholder.multiEmail))
            return true;
    }

    return false;
}

export function areEmailsWithPlaceholdersValid(text, placeholders) {
    if (!text)
        return false;

    return text.split(",").every(e => isEmailOrEmailPlaceholder(e.trim(), placeholders, true));
}

export const lang = getLanguage();

export function pluralize(input, count) {
    if (!input)
        return '';
    if (count === 1)
        return input;

    if (lang === "es") {
        // Spanish
        var lower = input.toLowerCase();
        const last = lower[lower.length];
        if (last === 'a' || last === 'e' || last === 'i' || last === 'o' || last === 'u' || last === 'á' || last === 'é' || last === 'ó') {
            if (lower === "yo" || lower === "no")
                return input + "es";
            return input + "s";
        }
        else if (last === 'í' || last === 'ú') {
            if (lower === "menú")
                return "menús";
            return input + "es";
        }
        else if (last === 'y' || last === 'l' || last === 'r' || last === 'n' || last === 'd' || last === 'z' || last === 'j' || last === 's' || last === 'x' || endsWith(lower, "ch")) {
            if (last === 'z')
                return input.substring(last, last.length - 1) + "ces";
            if ((last === 'n' || last === 's') && input.length > 1) {
                if (lower[lower.length - 2] === 'á')
                    input[input.length - 2] = "a";
                if (lower[lower.length - 2] === 'é')
                    input[input.length - 2] = "e";
                if (lower[lower.length - 2] === 'í')
                    input[input.length - 2] = "i";
                if (lower[lower.length - 2] === 'ó')
                    input[input.length - 2] = "o";
                if (lower[lower.length - 2] === 'ú')
                    input[input.length - 2] = "u";
            }
            return input + "es";
        }
        else if (lower === "análisis" || lower === "jueves" || lower === "tórax") {
            return input;
        }
        else {
            return input + "s";
        }
    }
    else {
        // English
        var lower = input.toLowerCase();
        if (endsWith(lower, 'child'))
            return input + 'ren';
        else if (endsWith(lower, 'person'))
            return input.substring(0, input.length - 5) + 'eople';
        else if (endsWith(lower, 'y'))
            return input.substring(0, input.length - 1) + 'ies';
        else if (endsWith(lower, 'man'))
            return input.substring(0, input.length - 2) + 'en';
        else if (endsWith(lower, 'syllabus') ||
            endsWith(lower, 'stimulus') ||
            endsWith(lower, 'alumnus'))
            return input.substring(0, input.length - 2) + 'i';
        else if (endsWith(lower, 'thesis') ||
            endsWith(lower, 'crisis') ||
            endsWith(lower, 'diagnosis') ||
            endsWith(lower, 'prognosis'))
            return input.substring(0, input.length - 2) + 'es';
        else if (endsWith(lower, 'self') ||
            endsWith(lower, 'half'))
            return input.substring(0, input.length - 1) + 'ves';
        else if (endsWith(lower, 'quiz'))
            return input + 'zes';
        else if (endsWith(lower, 's') ||
            endsWith(lower, 'x') ||
            endsWith(lower, 'z') ||
            endsWith(lower, 'ch') ||
            endsWith(lower, 'sh'))
            return input + 'es';
        else
            return input + 's';
    }
}

export function distinct(arr) {
    return arr.filter((item, i, list) => list.indexOf(item) === i);
}

export function sum(list, selector) {
    return list.reduce((total, i) => total + (selector(i) || 0), 0);
}

export function count(list, selector) {
    return list.reduce((cnt, i) => cnt + (selector(i) ? 1 : 0), 0);
}

export function getUniqueName(name, names, maxLength) {
    let test = name;
    let i = 2;
    while (names.indexOf(test) >= 0) {
        const add = " (" + i + ")";
        test = name.substring(0, (maxLength || 100000) - add.length) + add;
        i++;
    }
    return test;
}

export function getLanguage() {
    // support for HTML 5.1 "navigator.languages"
    var language = null;
    var languages = window.navigator.languages;
    if (Array.isArray(languages)) {
        for (var i = 0; i < languages.length; i++) {
            language = languages[i];
            if (language && language.length)
                break;
        }
    }

    // support for other well known properties in browsers
    if (!language || !language.length) {
        var keys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
        for (var i = 0; i < keys.length; i++) {
            language = window.navigator[keys[i]];
            if (language && language.length)
                break;
        }
    }

    //Check For Spanish
    if (language.indexOf("es") === 0)
        return "es";
    return "en";
}

export function checkPasswordStrength(password) {
    return /(?=.*\d)(?=.*[A-Za-z]).{8,}$/.test(password);
}

export function checkPasswordStrengthMinistryID(password) {
    return /(?=.*\d)(?=.*[A-Za-z])(?=.*[A-Z]).{8,}$/.test(password);
}

let frequencyNames = null;
export function formatFrequency(frequency) {
    if (!frequency)
        return "";

    if (frequencyNames === null) {
        frequencyNames = {};
        getFrequencies().forEach(freq => frequencyNames[freq.key.toString()] = freq.name);
    }
    return frequencyNames[frequency.toString()] || frequency;
}

export function navigateToURL(url) {
    window.open(url, '_blank').focus();
}
